function BackProduct() {
  if (document.querySelector('html').getAttribute('data-collection-handle')) {
    document.querySelectorAll('.product__item a').forEach(item => {
      item.addEventListener('click',function(e) {
        var productElement = item.closest('.product__item');
        console.log()
        sessionStorage.setItem('lastViewedCollection',`${productElement.dataset.collection}`);
        sessionStorage.setItem('lastViewedElement',`/collections/${productElement.dataset.collection}?page=${productElement.dataset.pagination}#${productElement.id}`);
      });
    });
  }
}

BackProduct();

function autoLoader() {
  const current_url = window.location.pathname;
  if (current_url.includes("collections") || current_url.includes("search")) {
    var products_on_page = document.getElementById("product-grid");

    if (!products_on_page) return;

    var next_url = products_on_page.getAttribute("data-next-url");
    var loadprev_btn = document.querySelector(".load-prev-cstm-btn");
    var prev_url = products_on_page.getAttribute('data-prev-url');
    var loadmore_btn = document.querySelector(".load-more-cstm-btn");

    function loadPreviousProducts() {
      if (prev_url) {
        fetch(prev_url)
          .then((response) => {
            loadprev_btn.style.display = "none";
            return response.text();
          })
          .then((data) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(data, "text/html");
            var return_html = doc.body;
            var main_html = return_html.querySelector("#product-grid");
            var main_html_child = main_html.querySelectorAll(".grid__item");
            var new_url = main_html.getAttribute("data-prev-url");
            prev_url = new_url;
            products_on_page.setAttribute("data-prev-url", prev_url)
            var mainProductWrapper = document.querySelector(".product-grid");
            var TempArr = [];
            for (var x =  main_html_child.length; x--;) {
                TempArr.push( main_html_child[x]);
            }
            main_html_child = TempArr;
            setTimeout(() => {
              main_html_child.forEach((value, index) => {
                document.querySelector(".product-grid").prepend(value);
              });
              var mainproductWrapper = document.querySelector('#product-grid');
              if(mainproductWrapper.classList.contains('grid__layout-2')
              || mainproductWrapper.classList.contains('grid__layout-4')
              || mainproductWrapper.classList.contains('layout__gallary-view')
              ){
                var featuredBannerImages = document.querySelectorAll('.featured__banner-image');
                featuredBannerImages.forEach(productImage =>{
                 const productImageSrc = productImage.getAttribute('data-productimage');
                 productImage.src = productImageSrc;
                });
              }

              cardAtcBtn();
              variantListClose();
              BackProduct();

              if (!prev_url) {
                products_on_page.setAttribute('data-prev-url','');
                document.querySelector('#product-grid').setAttribute('data-prev-url','');
                prev_url = '';
                loadprev_btn.style.display = "block";
                loadprev_btn.classList.add("ds-no-more-products-left");
                loadprev_btn.classList.add("ds-no-more-products-left");
                loadprev_btn.textContent="No more products";
              }
            }, 600);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }

    if (document.querySelectorAll('#load-prev-cstm-btn').length > 0) {
      document.querySelector('#load-prev-cstm-btn').addEventListener('click', () => {
        loadPreviousProducts();
      });
    }

    var btnClick = new Event("click");
    var loadprev_btn = document.querySelector(".load-prev-cstm-btn")
    document.addEventListener("scroll", function () {
      if (prev_url) {
        prev_url = document.querySelector('#product-grid').getAttribute("data-prev-url");
      }
      var collectionTplElm = document.querySelector(".collection_top-wrapper");
      var collectionTop = window.innerHeight;
      var collectionHeight = collectionTplElm?.clientHeight;
      var posTop = collectionTop + collectionHeight - window.innerHeight;

      if (window.scrollY < 1000) {
        if (loadprev_btn) {
          if (!loadprev_btn.classList.contains('btn-disabled')) {
            loadprev_btn.dispatchEvent(btnClick);
            loadprev_btn.classList.add('btn-disabled');
            setTimeout(function() {
              if (loadprev_btn) {
                loadprev_btn.classList.remove('btn-disabled');
              }
            }, 3000);
          }
        }
      }
    });
  }
}

autoLoader();
